var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarReview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 4L15.912 7.703L20 8.297L17 11L18 15L14 12.75L10 15L11 11L8 8.297L12.2 7.703L14 4Z",
    fill: "#737791"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.736 26L14 25L18 18H24C24.2628 18.0004 24.523 17.9489 24.7658 17.8486C25.0087 17.7482 25.2293 17.6009 25.4151 17.4151C25.6009 17.2293 25.7482 17.0087 25.8486 16.7658C25.9489 16.523 26.0004 16.2628 26 16V4C26.0004 3.73725 25.9489 3.477 25.8486 3.23417C25.7482 2.99134 25.6009 2.7707 25.4151 2.58491C25.2293 2.39911 25.0087 2.25181 24.7658 2.15144C24.523 2.05107 24.2628 1.9996 24 2H4C3.73725 1.9996 3.477 2.05107 3.23417 2.15144C2.99134 2.25181 2.7707 2.39911 2.58491 2.58491C2.39911 2.7707 2.25181 2.99134 2.15144 3.23417C2.05107 3.477 1.9996 3.73725 2 4V16C1.9996 16.2628 2.05107 16.523 2.15144 16.7658C2.25181 17.0087 2.39911 17.2293 2.58491 17.4151C2.7707 17.6009 2.99134 17.7482 3.23417 17.8486C3.477 17.9489 3.73725 18.0004 4 18H13V20H4C2.93913 20 1.92172 19.5786 1.17157 18.8284C0.421427 18.0783 0 17.0609 0 16V4C0 2.93913 0.421427 1.92172 1.17157 1.17157C1.92172 0.421427 2.93913 0 4 0H24C25.0609 0 26.0783 0.421427 26.8284 1.17157C27.5786 1.92172 28 2.93913 28 4V16C28 17.0609 27.5786 18.0783 26.8284 18.8284C26.0783 19.5786 25.0609 20 24 20H19.165L15.736 26Z",
    fill: "#737791"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarReview);
export default __webpack_public_path__ + "static/media/sidebar_review.5e0e6c5da9c51cfaf8304074cff4a4b3.svg";
export { ForwardRef as ReactComponent };